<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.save()"
        extra-large
        ref="RkmModal"
        title="Cadastro de loteamento"
    >
        <Form
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {Form},
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-loteamento-form')
        },
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleExit(loteamento) {
            this.$emit('save', loteamento)
            this.$refs.RkmModal.hide()
        },
    }
}
</script>